import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: Returns true when CODE_SESSIONS_ENABLED_FF is set to "true" on the
// server. Reads from the public /app-config endpoint — no auth or integration
// permission required. Mirrors useAgentsEnabled.
export const useCodeSessionsEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.features.isCodeSessionsEnabled ?? false;
};
